var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcon1 = function SvgIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 50.375c-2.3-2.3-.775-7.125-1.95-9.95C10.5 37.6 6 35.125 6 32c0-3.125 4.45-5.5 5.675-8.425 1.225-2.925-.35-7.65 1.95-9.95 2.3-2.3 7.125-.775 9.95-1.95C26.4 10.5 28.875 6 32 6c3.125 0 5.5 4.45 8.425 5.675 2.925 1.225 7.65-.35 9.95 1.95 2.3 2.3.775 7.125 1.95 9.95C53.5 26.4 58 28.875 58 32c0 3.125-4.45 5.5-5.675 8.425-1.225 2.925.35 7.65-1.95 9.95-2.3 2.3-7.125.775-9.95 1.95C37.6 53.5 35.125 58 32 58c-3.125 0-5.5-4.45-8.425-5.675-2.925-1.225-7.65.35-9.95-1.95Z",
    stroke: "#888DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 26 28.325 40 21 33",
    stroke: "#888DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIcon1;